import React from "react";
import { Link } from "react-router-dom";
import { contactPageData, servicesData } from "../data/mockData";
import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";

const ContactUs = () => {
  return (
    <div className="overflow-hidden">
      {/* Header */}
      <section className="pt-32 pb-8 md:pt-40 md:pb-12">
        <div className="max-w-[1320px] mx-auto px-6">
          <p
            className="text-[#F26522] text-[15px] font-semibold mb-2"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Urban Hunter
          </p>
          <h1
            className="text-[40px] md:text-[56px] font-bold leading-tight mb-4"
            style={{ fontFamily: "'Poppins', sans-serif", color: "#1B1B3A" }}
          >
            {contactPageData.title}
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="pb-16 md:pb-24">
        <div className="max-w-[1320px] mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Left side - Contact Info */}
            <div className="lg:w-1/2">
              <h2
                className="text-[28px] md:text-[36px] font-bold mb-6"
                style={{ fontFamily: "'Poppins', sans-serif", color: "#1B1B3A" }}
              >
                {contactPageData.heading}
              </h2>
              <p
                className="text-[#555] text-[16px] leading-relaxed mb-10"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {contactPageData.description}
              </p>

              {/* Phone */}
              <div className="mb-8">
                <p className="text-[#888] text-[13px] uppercase tracking-wider mb-2" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  Phone number:
                </p>
                <a
                  href={`tel:${contactPageData.phone.replace(/-/g, "")}`}
                  className="text-[#1B1B3A] text-[20px] font-bold no-underline hover:text-[#F26522] transition-colors flex items-center gap-3"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  <Phone size={20} className="text-[#F26522]" />
                  {contactPageData.phone}
                </a>
              </div>

              {/* Email */}
              <div className="mb-8">
                <p className="text-[#888] text-[13px] uppercase tracking-wider mb-2" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  Email address:
                </p>
                <a
                  href={`mailto:${contactPageData.email}`}
                  className="text-[#1B1B3A] text-[20px] font-bold no-underline hover:text-[#F26522] transition-colors flex items-center gap-3"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  <Mail size={20} className="text-[#F26522]" />
                  {contactPageData.email}
                </a>
              </div>

              {/* Address */}
              <div className="mb-8">
                <div className="flex items-start gap-3">
                  <MapPin size={20} className="text-[#F26522] mt-1 flex-shrink-0" />
                  <div>
                    <p className="text-[#1B1B3A] text-[16px] leading-relaxed mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>
                      {contactPageData.address}
                    </p>
                    <a
                      href={contactPageData.mapLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#1B1B3A] text-[13px] font-bold uppercase tracking-wider no-underline border-b-2 border-[#1B1B3A] pb-1 hover:text-[#F26522] hover:border-[#F26522] transition-colors"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      View on Map
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Right side - Services Sidebar + Image */}
            <div className="lg:w-1/2">
              <div className="bg-[#F8F6FF] rounded-2xl p-8 mb-8">
                <h3
                  className="text-[14px] font-semibold uppercase tracking-widest text-[#888] mb-6"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Get in touch
                </h3>
                <div className="space-y-4">
                  {servicesData.map((service) => (
                    <Link
                      key={service.id}
                      to={service.link}
                      className="flex items-center justify-between p-4 bg-white rounded-xl no-underline group hover:shadow-md transition-all duration-300"
                    >
                      <span
                        className="text-[#1B1B3A] text-[15px] font-semibold group-hover:text-[#F26522] transition-colors"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                      >
                        {service.title}
                      </span>
                      <ArrowRight size={16} className="text-[#ccc] group-hover:text-[#F26522] transition-colors" />
                    </Link>
                  ))}
                </div>
              </div>

              <Link
                to="/services"
                className="inline-flex items-center gap-2 text-[#1B1B3A] text-[14px] font-semibold no-underline hover:text-[#F26522] transition-colors"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                Explore all solutions
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
